module.exports = __webpack_public_path__ + "media/images/products/1-612d00ff29dce08ead618f9aa94ceece.jpg";